<template>
<v-sheet style="background-color:#fff;height:100%">
    <v-toolbar floating elevation="0" style="border-bottom:1px solid #ddd" pb-5>
                    <!--v-btn :to="{name:'insights'}" icon text dark>
                        <v-icon color="black">arrow_back</v-icon>
                    </v-btn-->
                    <v-toolbar-title>RELATÓRIOS </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
    <v-container fluid :fill-height="(infos == null)">
        <v-layout wrap style="height:100%">
           
            <v-flex xs12 >
            
                    <template v-if="infos == null" >
                        <v-layout text-center align-center justify-center style="height:100%" >
                            <v-flex xs12>
                                <h1 class="display-1 mb-5">
                                    <span class="font-weight-bold">Ainda não há dados suficientes para criar</span>
                                    os seus Relatórios
                                </h1>
                                <p class="subheading font-weight-regular my-5">
                                    Seus relatórios financeiros e de streamings começam a aparecer
                                    <br />
                                    <b>após</b> 45 dias do lançamento do seu produto.
                                    <br />
                                    <br />Fique tranquilo sempre que tivermos
                                    <br />novos dados vamos te notificar!
                                </p>
                            </v-flex>
                        </v-layout>
                    </template>

                    <template  v-if="infos != null">
                        
                        <v-layout style="height:100%" wrap>
                        <v-flex xs12 md12 px-1 pb-2 >
                            <v-card outlined py-5>                                
                                <v-card-title pt-5>Saldo atual: {{formatarDinheiro(infos.val_d)}}</v-card-title>                                
                            </v-card>
                        </v-flex>
                        <v-flex px-1 py-1 xs12 md4 lg-2 v-for=" (parceiro, x) in parceiros" :key="x" >
                            <v-card outlined py-5>
                                <v-card-title pt-5 class="text-uppercase"> {{x}}</v-card-title>
                                <div class="px-4 caption"></div>
                                <v-simple-table>
                                    <template v-slot:default>
                                    <thead>
                                        <tr>                                            
                                            <th class="text-center">Plays/Views</th>
                                            <th class="text-center">Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,moeda) in parceiro" :key="moeda">                                            
                                            <td class="text-center">{{item.q}}</td>
                                            <td class="text-center">{{ moeda }} {{ formatarDinheiro(item.v, "", 2) }}</td>
                                        </tr>
                                    </tbody>
                                    </template>
                                </v-simple-table>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn :to='{name:"reports_platform", params:{platform:x}}' icon  color="green"><v-icon>view_list</v-icon></v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                         </v-layout>
                    </template>
              
            </v-flex>
        </v-layout>
    </v-container>
</v-sheet>
</template>

<script>
import { money } from "../../../app/general";
import ReportsService from "../../../app/Rest/reports";

var _money = new money();
var reportsService = null;

export default {     
    data: () => ({
        activeBtn: 1,
        infos: null,       
        parceiros:[]       
    }),   
    beforeCreate(){              
        reportsService = ReportsService.build();
      
    },
    mounted(){
          this.loadUserDashboard();  
    },
    methods: {                
        loadUserDashboard(){
            this.$store.commit("loading");

            reportsService.get_compiled().then( e =>{
                
                if(Object.keys(e.items).length>0){
                    this.infos = {val_d:this.$store.getters.current_credit, parceiros: e.items};                 
                    this.parceiros = this.infos.parceiros;
                }else{                   
                    this.infos = null;
                }
                

            }).finally(()=>{
                this.$store.commit("loading", false);
            });
           
        },
        formatarDinheiro(valor, moeda="R$", casas=2) {
            let t = valor;
            _money.set_currency(moeda)
            return _money.formatWithCurrency(t, casas, ",");
        }
    }
}
</script>
